/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types'
], function(
	React,
	PropTypes
) {

	return class SkeletonPlaceholder extends React.Component {
		static propTypes = {
			placeholderImage: PropTypes.img,
			placeholderSVG: PropTypes.svg,
			alt: PropTypes.string,
			shown: PropTypes.bool
		};

		remove() {
			this.props.shown = false;
		}

		render() {
			if (this.props.shown) {
				if (this.props.placeholderImage) {
					let img = this.props.placeholderImage;
					return <div className="skeletonPlaceholder">
						<div className="shimmer">
							<img src={img} alt={this.props.alt} />
						</div>
					</div>;
				} else if (this.props.placeholderSVG) {
					return <div className="skeletonPlaceholder">
						<div className="shimmer">
							<svg className="shimmer" x="0px" y="0px" width="256px" height="256px" viewBox="0 0 256 256">
								<use xlinkHref={this.props.placeholderSVG}></use>
							</svg>
						</div>
					</div>;
				} else {
					return <div className="skeletonPlaceholder noimage"></div>;
				}

			} else {
				return null;
			}
		}
	};
});
